<template>
  <div>
    <div class="qyxx_list" v-if="list.length > 0">
      <div class="qyxx_item" v-for="(item, index) in list" :key="index">
        <div
          class="title fw pointer_line"
          @click="
            $goDetail({
              _id: item._id,
              data_type: item.data_type || item._index,
            })
          "
        >
          {{ item.title }}
        </div>
        <div class="abs text_overflow2">
          {{ item.business_scope }}
        </div>
      </div>
    </div>
    <img
      v-else
      style="height: 254px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_data.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonQyxx",
  props: ["list"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="less" scoped>
.qyxx_list {
  .qyxx_item {
    height: 120px;
    border-radius: 6px;
    background: url("../../../assets/imgs/home/qy_bg.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 16px;
    padding: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      font-size: 16px;
      color: #1d4a77;
      margin-bottom: 12px;
      line-height: 20px;
    }
    .abs {
      font-size: 15px;
      color: #1d2541;
      line-height: 25px;
    }
  }
}
</style>